import { render, staticRenderFns } from "./AmazonCareOf.vue?vue&type=template&id=8cc05980&scoped=true"
import script from "./AmazonCareOf.vue?vue&type=script&lang=js"
export * from "./AmazonCareOf.vue?vue&type=script&lang=js"
import style0 from "./AmazonCareOf.vue?vue&type=style&index=0&id=8cc05980&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc05980",
  null
  
)

export default component.exports